import { QuoteListItem } from '../../components/QuoteListItem'

export const QuoteAutoExecuteFailedListItem = (props: {
  taskId: string
  isSelected: boolean
  hideUnreadIndicator?: boolean
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}) => <QuoteListItem {...props} description="Auto-execute failed" />
